export default async function fetchData(url, options = {}) {
  const responseRaw = await fetch(url, options);
  const response = await responseRaw.json();

  return response;
}
